// extracted by mini-css-extract-plugin
export default {"blogAside":"blog_blogAside__w+nup"};